import React from 'react';

const defaultState = {
  message: '',
  userRoles: [],
};

export default React.createContext(defaultState);
